import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import notificationsServices from '@src/services/notifications.service';

export const getPendingNotificationsDashboard = createAsyncThunk(
  'getPendingNotificationsDashboard',
  async ({ vouId = 1, page, pageSize }, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId && !vouId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      if (vouId === 4) {
        return await notificationsServices.getPendingNotifications({
          id: 'getPendingNotifications',
          customerId: customerId,
          vouId: vouId,
          page: page,
          pageSize: pageSize,
        });
      } else {
        // 4 seri çağrı yerine Promise.all ile paralel fetch: latency düşer, SP sayısı aynı kalır.
        const [tcar, tmarket, tgift, tres] = await Promise.all([
          notificationsServices.getPendingNotifications({
            id: 'getPendingNotificationsDashboard',
            customerId: customerId,
            vouId: 4,
            page: page,
            pageSize: pageSize,
          }),
          notificationsServices.getPendingNotifications({
            id: 'getPendingNotificationsDashboard',
            customerId: customerId,
            vouId: 11,
            page: page,
            pageSize: pageSize,
          }),
          notificationsServices.getPendingNotifications({
            id: 'getPendingNotificationsDashboard',
            customerId: customerId,
            vouId: 94,
            page: page,
            pageSize: pageSize,
          }),
          notificationsServices.getPendingNotifications({
            id: 'getPendingNotificationsDashboard',
            customerId: customerId,
            vouId: vouId,
            page: page,
            pageSize: pageSize,
          }),
        ]);
        if (tres?.data?.items && tcar?.data?.items && tmarket?.data?.items && tgift?.data?.items)
          tres.data.items = tres.data.items.concat(tcar.data.items, tmarket.data.items, tgift.data.items);
        return tres;
      }
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  notificationList: [],
  pagedProperty: {
    currentPage: 1,
    page: 1,
    pageSize: 4,
    totalCount: 0,
    totalPages: 0,
  },
};

export const notificationsDashboardSlice = createSlice({
  name: 'notificationsDashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPendingNotificationsDashboard.fulfilled, (state, action) => {
      state.notificationList = action?.payload?.data?.items || [];
      state.pagedProperty = action?.payload?.data?.pagedProperty || initialState?.pagedProperty;
    });
    builder.addCase(getPendingNotificationsDashboard.rejected, (state) => {
      state.notificationList = initialState.list;
      state.pagedProperty = initialState?.pagedProperty;
    });
  },
});
